import { ChatPane } from '@/features/chat/ChatPane';
import {
  AI_AGENT_CONTEXTS,
  APPS_CONTEXT_LABEL,
  MISSION_TEMPLATES,
  useAppsStore,
} from './AppsStore';

export function AppsIntelligence() {
  return (
    <ChatPane
      title="Apps Intelligence"
      scopeLabel="Apps"
      suggestions={[
        'Which contexts have the AI Agent enabled?',
        'Is the DJI FH2 Workflow Trigger configured?',
      ]}
      initialMessage="Apps loaded: 2 available. Enable the AI Agent per context, or configure the DJI FH2 Workflow Trigger to arm a flight mission against a tenant MQTT broker topic."
      send={async (q, _hist, onToken) => streamMock(buildAnswer(q), onToken)}
    />
  );
}

function buildAnswer(q: string) {
  const { aiEnabled, dji } = useAppsStore.getState();
  const enabled = AI_AGENT_CONTEXTS.filter((ctx) => aiEnabled[ctx]).map(
    (ctx) => APPS_CONTEXT_LABEL[ctx],
  );
  const ql = q.toLowerCase();

  if (/agent|enabled|context/.test(ql)) {
    return enabled.length
      ? `AI Agent is currently enabled for: ${enabled.join(', ')}.`
      : 'AI Agent is not enabled for any context yet — open the AI Agent app to turn it on.';
  }

  if (/dji|workflow|trigger|mission|mqtt|broker/.test(ql)) {
    if (!dji.configured) {
      return 'DJI FH2 Workflow Trigger is not fully configured yet — add your Organization ID, API key, a broker topic, and a trigger event.';
    }
    const mission = MISSION_TEMPLATES.find((item) => item.id === dji.missionTemplateId);
    const trigger =
      dji.triggerType === 'workflow'
        ? `workflow "${dji.workflowName}"`
        : mission
          ? `"${mission.name}"`
          : 'a flight mission';
    return `DJI FH2 Workflow Trigger is configured — watching ${dji.brokerTopic} to trigger ${trigger}.`;
  }

  return 'I can help with the AI Agent and DJI FH2 Workflow Trigger apps — ask me which contexts have the agent enabled, or whether the DJI trigger is configured.';
}

async function streamMock(answer: string, onToken: (t: string) => void) {
  for (const word of answer.split(/(\s+)/)) {
    await new Promise((resolve) => setTimeout(resolve, 28));
    onToken(word);
  }
}
